import { render, staticRenderFns } from "./KT-Notes.vue?vue&type=template&id=3ed6042c&scoped=true&lang=pug&"
import script from "./KT-Notes.vue?vue&type=script&lang=js&"
export * from "./KT-Notes.vue?vue&type=script&lang=js&"
import style0 from "./KT-Notes.vue?vue&type=style&index=0&id=3ed6042c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed6042c",
  null
  
)

export default component.exports